<template>
	<div class="resultado hello-wrapper">
		<div class="panel white-tilted-1">
			
			<div v-if="resultado != null" class="message">
				<div class="icon" :class="{ 'aprovado': resultado.Aprovado, 'reprovado': !resultado.Aprovado }">
				</div>
				<div class="title">
					{{ resultado.Aprovado ? 'Aprovado' : 'Reprovado'}}
				</div>
				<div v-if="!resultado.Aprovado" class="text">
					{{ texto }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from '@/http/axios.js'
	import bus from '@/bus/event-bus.js';
	export default {
		props: ['simulado'],
		data() {
			return {
				resultado: null
			}
		},

		computed: {
			acertos() {
				return this.resultado.Acertos.toString().padStart(2, '0')
			},

			total() {
				return this.resultado.Total.toString().padStart(2, '0')
			},
			
			texto() {
				return this.resultado.Aprovado ? '' : 'Procure seu professor ou coordenador pedagógico para maiores informações.';
			}
		},

		methods: {
			getResultado() {
				bus.$emit('loading', true)
				http.post('resultado', { id: this.simulado.Id }).then((r) => {
					this.$set(this, 'resultado', r.data)
					bus.$emit('loading', false)
				})
			},
			getNota(nota) {
				if(nota == "B1L") {
					return "B1";
				}

				if(nota == "B1U") {
					return "B1"
				}

				return nota;
			},

			getSubnota(nota) {
				if(nota == 'B1L') {
					return "(metade inferior) ou abaixo"
				}

				if(nota == 'B1U') {
					return "(metade superior)"
				}
			}
		},

		mounted() {
			this.getResultado()
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/result/Resultado.vue